import React, { useContext } from 'react';
import { TextField } from '@material-ui/core';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { AppContext } from '../../context';
import {} from '../Context/constants';
import {
  FilterHeader,
  FilterContainer,
} from '../../components/layout/WrapperDiv';
import { SummaryFilterContext } from './SummaryFilters';
import { filterByLength } from '../../translations/en.json';

export const LengthFilter = () => {
  const { patient } = useContext(AppContext);
  const { minDurationHH, minDurationMM } = useContext(VisitsGlobalContext);
  const { tentativeFilters, updateTentFilters, getInputStyles } = useContext(
    SummaryFilterContext,
  );

  const setLengthHH = (length: any) => {
    updateTentFilters({ ...tentativeFilters, minDurationHH: length });
  };
  const setLengthMM = (length: any) => {
    updateTentFilters({ ...tentativeFilters, minDurationMM: length });
  };

  const lenHHChanged = minDurationHH !== tentativeFilters.minDurationHH;
  const lenMMChanged = minDurationMM !== tentativeFilters.minDurationMM;

  const hhClasses = getInputStyles(lenHHChanged);
  const mmClasses = getInputStyles(lenMMChanged);

  const inputHHProps = {
    classes: {
      root: hhClasses.root,
      input: hhClasses.input,
    },
  };
  const inputMMProps = {
    classes: {
      root: mmClasses.root,
      input: mmClasses.input,
    },
  };

  return (
    <FilterContainer className="visit-log-length-filter">
      <FilterHeader selected={lenHHChanged || lenMMChanged}>
        {filterByLength}
      </FilterHeader>
      {patient || (
        <div style={{ display: 'flex', paddingTop: '8px' }}>
          <div style={{ display: 'flex', height: '10px' }}>
            <TextField
              label="HH"
              id="hour-edit"
              variant="outlined"
              value={tentativeFilters.minDurationHH}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={inputHHProps}
              onChange={(e: any) => {
                setLengthHH(e.target.value);
              }}
              size="small"
            />
            <div>:</div>
            <TextField
              label="MM"
              id="min-edit"
              variant="outlined"
              value={tentativeFilters.minDurationMM}
              InputProps={inputMMProps}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e: any) => {
                setLengthMM(e.target.value);
              }}
              size="small"
            />
          </div>
        </div>
      )}
    </FilterContainer>
  );
};
